import { useState } from "react";
import { addMonths, subMonths } from "../../../date-fns/index.js";
import { todayBrowserDate } from "./constants.js";
import { formatDate, parseDate } from "./utils.js";
const defaultLayout = {
  daySize: 30,
  dayGapY: 8,
  dayGapX: 6,
  monthGap: 60
};
function useComputeCalendarConfiguration(props = {}) {
  const {
    layout,
    minDate: rawMinDate,
    maxDate: rawMaxDate,
    todayDate: rawTodayDate,
    dateFnsOptions,
    initialVisibleDate: rawInitialVisibleDate,
    ...rest
  } = props;
  const todayDate = rawTodayDate ? parseDate(rawTodayDate, dateFnsOptions) : todayBrowserDate;
  const minDate = rawMinDate ?? formatDate(subMonths(todayDate, 13), dateFnsOptions);
  const maxDate = rawMaxDate ?? formatDate(addMonths(todayDate, 13), dateFnsOptions);
  const [referenceDate, setReferenceDate] = useState(
    () => rawInitialVisibleDate ? parseDate(rawInitialVisibleDate, dateFnsOptions) : todayDate
  );
  return {
    minDate,
    maxDate,
    todayDate: formatDate(todayDate, dateFnsOptions),
    referenceDate,
    setReferenceDate,
    dateFnsOptions: {
      weekStartsOn: 0,
      ...dateFnsOptions
    },
    monthsCount: 1,
    monthLabelFormat: "MMMM",
    dayLabelFormat: "EEEEEE",
    layout: {
      ...defaultLayout,
      ...layout
    },
    includeAdjacentMonthDays: false,
    ...rest
  };
}
function getPlaceholderCoreProps() {
  const referenceDate = /* @__PURE__ */ new Date();
  const setReferenceDate = () => void 0;
  const dateFnsOptions = {
    weekStartsOn: 0
  };
  const todayDate = formatDate(/* @__PURE__ */ new Date(), dateFnsOptions);
  return {
    layout: defaultLayout,
    minDate: todayDate,
    maxDate: todayDate,
    todayDate,
    monthsCount: 1,
    referenceDate,
    dayLabelFormat: "EEEEEE",
    dateFnsOptions,
    setReferenceDate,
    monthLabelFormat: "MMMM",
    includeAdjacentMonthDays: false
  };
}
export {
  getPlaceholderCoreProps,
  useComputeCalendarConfiguration
};
//# sourceMappingURL=useComputeCalendarConfiguration.js.map
